<!-- @veltra/icons generated sha256:c4bbfa9bb453724b gen:8 source:src/svg/normal/prompt.svg -->
<script setup lang="ts">
defineOptions({ name: 'Prompt' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path
      d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM7 11h10M7 15h6M7 7h8"
    />
  </svg>
</template>
